export class StorageUtil {

  static get(key: string): string {
    return window.localStorage.getItem(key);
  }

  static set(key: string, value: string): void {
    window.localStorage.setItem(key, value);
  }

  static delete(key: string): void {
    window.localStorage.removeItem(key);
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/storage.ts